import React, { useEffect, useState } from 'react';
import { styles } from '../Styles/Styles';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import { NavLink } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Bedroom, FavouriteIcon, LandArea, LocationIcon } from './svgIcons';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import userIcon from '../assets/images/user.svg'
import Lightbox from 'yet-another-react-lightbox';

const SimilarListing = ({ Data, type, loading }) => {
    const [propData, setPropData] = useState([1, 2, 3, 4]);
    useEffect(() => {
        if (!loading) {
            setPropData(Data);
        }
    }, [Data, loading]);
    return (
        <div>
            <div className='my-10'>
                {type && <h1 className={styles.title1 + 'text-start mb-5 px-0'}>{type}</h1>}
                {<Carousel
                    swipeable={true}
                    draggable={false}
                    responsive={responsive}
                    // ssr={true}
                    infinite={true}
                    autoPlay={!loading}
                    autoPlaySpeed={2000}
                    keyBoardControl={true}
                    transitionDuration={2000}
                    // partialVisbile
                    customButtonGroup={<div className=''></div>}
                    containerClass='mx-auto'
                    itemClass='pt-2'
                    customLeftArrow={
                        <div className='absolute'>
                            {!loading && <>
                                <button className='sm:hidden bg-black bg-opacity-30 opacity-70 hover:bg-opacity-60 rounded-full flex justify-center items-center p-2'>
                                    <ArrowLeft classname={'w-7 h-7 text-white'} />
                                </button>
                                <button className='hidden sm:flex justify-center items-center rounded-full  bg-white shadow-md p-4'>
                                    <i class="fa-solid fa-arrow-left  text-gray-500 "></i>
                                </button>
                            </>}
                        </div>
                    }
                    customRightArrow={
                        <div className='absolute right-0'>
                            {!loading && <>
                                <button className='sm:hidden bg-black bg-opacity-30 opacity-70 hover:bg-opacity-60 rounded-full flex justify-center items-center p-2'>
                                    <ArrowRight classname={'w-7 h-7 text-white'} />
                                </button>
                                <button className='hidden rounded-full sm:flex justify-center items-center bg-white shadow-md p-4'>
                                    <i class="fa-solid fa-arrow-right text-gray-500  "></i>
                                </button>
                            </>}
                        </div>
                    }
                >
                    {propData?.length > 0 &&
                        propData?.map((item, index) => {
                            return (
                                <div key={index} className=' rounded-md shadow-lg border-[1px] h-full mx-4  group'>
                                    <div>
                                        <NavLink to={`/${item.link ? item.link : item.url}`}
                                        // onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                        >
                                            <div className='relative items-center rounded-t-md overflow-hidden hover:cursor-pointer'>
                                                {loading ? <Skeleton className='h-[230px]' /> : <img alt='' src={item.image ? item.image : item.img}
                                                    className='h-[230px] w-full transform transition-transform hover:scale-110 duration-1000'
                                                />}
                                            </div>
                                        </NavLink>
                                        <div className='h-[70px] flex gap-1 justify-between items-center p-2 pl-1 bg-gradient-to-b from-gray-100 to-gray-400 group-hover:bg-gradient-to-b group-hover:form-gray-300 group-hover:to-black'>
                                            {loading ? <Skeleton className='' /> : <>
                                                <NavLink
                                                    // onClick={() => window.scrollTo({ top: 0 })}
                                                    className='flex gap-1 z-50'>
                                                    <img alt='' src={item.userDetails?.image ? item.userDetails?.image : userIcon} className='h-10 w-10 hidden group-hover:block rounded-full hover:cursor-pointer' />
                                                    <p className='text-sm block sm:hidden group-hover:block text-white mt-2 hover:cursor-pointer '>{item.userDetails?.name}</p>
                                                </NavLink>
                                                <div className='flex justify-between gap-1'>
                                                    {item?.imageGallery && item?.imageGallery?.length > 0 && <div
                                                        className=' flex sm:hidden group-hover:flex rounded-full items-center justify-center h-8 w-8 p-1 bg-black bg-opacity-60 hover:cursor-pointer'
                                                    //  onClick={() => setOpenGallery(true)}
                                                    >
                                                        <i class="fa-solid fa-camera text-gray-300"></i>
                                                    </div>}
                                                    <div
                                                        // onClick={() => addToFavouriteList(item?.id)} 
                                                        className=' block sm:hidden group-hover:block rounded-full p-1 bg-black bg-opacity-60 hover:cursor-pointer'>
                                                        <FavouriteIcon classname={'text-white'}
                                                        // classname={isFavourite ? 'fill-white' : '' + ' text-white'} 
                                                        />
                                                    </div>
                                                </div>
                                            </>}
                                            {/* <Lightbox
                                                open={openGallery}
                                                plugins={[Thumbnails, Download, Fullscreen, Zoom]}
                                                // thumbnails={item.imageGallery.slice(0, 8)}
                                                close={() => setOpenGallery(false)}
                                                slides={item?.imageGallery?.map((item, index) => {
                                                    return { src: item }
                                                })}
                                            /> */}
                                        </div>
                                        {!loading && <div className='flex absolute gap-2 top-5 right-5'>
                                            {(item.isFeatured && item.isFeatured != '') && <button className={styles.labelBtn + ' bg-gray-800'}>
                                                {item.isFeatured}
                                            </button>}
                                            <button className={styles.labelBtn + 'bg-orange-600'}>
                                                For {item.ListedFor}
                                            </button>
                                        </div>}
                                    </div>

                                    <div className='relative p-3 min-h-[260px] text-left'>
                                        <NavLink to={`/${item.link ? item.link : item.url}`} className={styles.title4 + ' line-clamp-2 hover:text-gray-500'}>{loading ? <Skeleton className='h-10' /> : item.title}</NavLink>
                                        {item.listed_by && <p className='text-sm mt-1'>by {item.listed_by}</p>}
                                        <div className='flex gap-1 mt-2'>
                                            <span className=''>
                                                <LocationIcon classname={'h-6 w-4 mt-[0.8px]'} />
                                            </span>
                                            <h1 className='font-medium text-sm text-gray-700 opacity-80 mt-1'>{loading ? <Skeleton /> : item.location}</h1>
                                        </div>

                                        {item.bedroom && <div className='flex mt-3'>
                                            <span className=''>
                                                <Bedroom classname={'h-5 w-4 mt-[1px] opacity-80'} />
                                            </span>
                                            <h1 className='text-sm ml-2'>{item.bedroom}</h1>
                                        </div>}
                                        {item.area && <div className='flex mt-2'>
                                            <span className=''>
                                                <LandArea classname={'h-5 w-4 mt-[1px]'} />
                                            </span>
                                            <h1 className='text-sm ml-2'>{item.area}</h1>
                                        </div>}
                                        {item.area && <div className='flex mt-2'>
                                            <span className=''>
                                                <i class="fa-solid fa-bars opacity-70 text-sm "></i>
                                            </span>
                                            <h1 className='text-sm ml-3'>{item.bhk ? (item.bhk + ' BHK') : ''}  {item.propertyType}</h1>
                                            {/* <p className='text-sm mt-4'>{item.bhk ? (item.bhk + ' BHK') : ''}  {item.propertyType}</p> */}
                                        </div>}
                                        {loading ? <Skeleton className='mt-5' count={3} /> : <div className='absolute bottom-1 flex justify-between w-[95%] mr-5'>
                                            {/* <p className={styles.title4 + 'mt-3'}>{"\u20B9"} 25 Cr</p> */}
                                            {(item.price && item.price != '0' && item.price != '0 ') ? <p className={styles.title4 + 'mb-3'}><i class={item.currency + ' text-base'}></i> {item.price}</p>
                                                :
                                                <button className={styles.btn + 'bg-green-600 px-4 my-2 text-white hover:bg-green-700'}>
                                                    ASK FOR PRICE
                                                </button>
                                            }
                                            {item.isVerified == 'Y' && <img alt='' src='https://www.truehomes24.com/assets/front_end/images/property/checkmark.svg' className='h-8 w-8 mt-2 ml-auto mr-4' />}
                                        </div>}
                                    </div>
                                </div>
                            )
                        })
                    }
                </Carousel>}
            </div>
        </div>
    );
}

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1200 },
        items: 3,
    },
    desktop: {
        breakpoint: { max: 1200, min: 1024 },
        items: 3,
    },
    tablet: {
        breakpoint: { max: 1024, min: 640 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 640, min: 0 },
        items: 1,
    },
};

export default SimilarListing;
